import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./app/components/App";
import { store } from "./app/redux/store";
import frameBuster from "./app/utils/frameBuster";
import "./main.css";
import * as serviceWorker from "./serviceWorker";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";

moment.locale("es-mx");

console.log("Time", Date.now());

ReactDOM.render(
  <React.StrictMode>
    <MuiPickersUtilsProvider
      libInstance={moment}
      utils={MomentUtils}
      locale={moment.locale("es-mx")}
    >
      <Provider store={store}>
        <App />
      </Provider>
    </MuiPickersUtilsProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// serviceWorker.resetCache();
/**
 * Frame buster: avoid web app being inside another sites.
 */
frameBuster.killer();
